<template>
  <div class="min-h-screen bg-white flex">
    <div
      class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24"
    >
      <div class="mx-auto w-full max-w-sm">
        <div>
          <img
            class="mx-auto w-auto"
            src="@/assets/FGT_Logo_Horizontal_Tagline.png"
            alt="Workflow"
          />
          <h2 class="text-center mt-6 text-3xl leading-9 font-extrabold text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <button type="button" @click="login()" class="mt-6 w-full flex shadow-sm rounded-md border border-gray-400">
            <div class="flex-shrink-0 flex items-center justify-center my-auto w-14 bg-white rounded-l-md">
              <icon-fgt
                  set="solid"
                  name="google"
                  class="h-10"
                />
            </div>
            <div class="flex-1 flex justify-center py-4 bg-blue-500 rounded-r-md text-white text-lg font-medium">
                Sign in with Google
            </div>
        </button>

        <div v-if="0" class="mt-6">
          <form action="#" method="POST">
            <div>
              <label
                for="email"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Email address
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="email"
                  type="email"
                  v-model="username"
                  required
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>

            <div class="mt-6">
              <label
                for="password"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Password
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  id="password"
                  type="password"
                  v-model="password"
                  required
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>

            <div v-if="error" class="mt-6">
              <span class="text-red-500">
                Something went wrong!
              </span>
            </div>

            <div class="mt-6">
              <span class="block w-full rounded-md shadow-sm">
                <button
                  type="button"
                  @click="login()"
                  class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition duration-150 ease-in-out"
                >
                  Sign in
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="hidden md:block relative w-0 flex-1">
      <img
        class="absolute inset-0 h-full w-full object-cover"
        src="//cdn.shopify.com/s/files/1/0059/8835/2052/files/hp-box2-flowering-trees.jpg?v=1582895471"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    login() {
      this.$router.push('/auth');
    },
  }
};
</script>
